import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { ClientPaymentEntity } from '../types/clientPayments.types';

type ClientPaymentsStore = {
  clientPayments: ClientPaymentEntity[];
  setClientPayments: (value: ClientPaymentEntity[]) => void;
  setRetriedPayment: (payment: ClientPaymentEntity) => void;
};

export const useClientPayments = create<ClientPaymentsStore>()(
  devtools(
    (set) => ({
      clientPayments: [],
      setClientPayments: (value) => set(() => ({ clientPayments: value })),
      setRetriedPayment: (payment) =>
        set((state) => {
          const updatedPayments = state.clientPayments.map((p) =>
            p.id === payment.id ? payment : p
          );
          return { clientPayments: updatedPayments };
        }),
    }),
    { name: 'clientPayments' }
  )
);
